import { memo, forwardRef, useCallback } from 'react';
import './InteractiveElement.scss';
import { jsx } from 'react/jsx-runtime';

/* External */
var ENTER_CODE = 'Enter';
var InteractiveElement = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var Tag = _ref.tag,
    children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    tabIndex = _ref.tabIndex,
    role = _ref.role,
    onClick = _ref.onClick,
    onMouseDown = _ref.onMouseDown,
    onKeyDown = _ref.onKeyDown,
    onMouseEnter = _ref.onMouseEnter,
    enableKeyDown = _ref.enableKeyDown;
  var isClickable = !!onClick || !!onMouseDown;
  var isFocusable = !!onKeyDown || !!onClick;
  var handleKeyDown = useCallback(function (event) {
    if (onClick && event.key === ENTER_CODE) {
      onClick(event);
    }
  }, [onClick]);
  return /*#__PURE__*/jsx(Tag, {
    className: "dtv-common-c-interactive-element ".concat(isClickable ? 'dtv-common-c-interactive-element--clickable' : '', " ").concat(isFocusable ? 'dtv-common-c-interactive-element--focusable' : '', " ").concat(className),
    style: style,
    role: role || (isClickable ? 'button' : undefined),
    tabIndex: tabIndex || (isFocusable ? 0 : undefined),
    onClick: onClick,
    onKeyDown: onKeyDown || (enableKeyDown ? handleKeyDown : undefined),
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    ref: ref,
    children: children
  });
});
InteractiveElement.defaultProps = {
  tag: 'div',
  children: null,
  className: '',
  style: undefined,
  tabIndex: undefined,
  role: undefined,
  onClick: undefined,
  onMouseDown: undefined,
  onKeyDown: undefined,
  onMouseEnter: undefined,
  enableKeyDown: false
};
var InteractiveElement$1 = /*#__PURE__*/memo(InteractiveElement);

export { InteractiveElement$1 as default };
//# sourceMappingURL=InteractiveElement.js.map
